// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ZX6MJ","header":"styles_header__vOGf7"};